module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "topictitle1",
    attrs: {
      "id": "de1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/nav#nde1"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Dedication")]), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "dedication_group"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("This book is dedicated to my children,")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("Kahbran, Eden, and Mimi,")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("as well as all those who are moved to fan the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "foreign_language"
  }, [_c('i', [_vm._v("✭")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f12c72e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 63
// module chunks = 0